import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCQgmW71D3t6c30iuzpmSL1nitJOjD915U",
  authDomain: "linkedin-ccee8.firebaseapp.com",
  projectId: "linkedin-ccee8",
  storageBucket: "linkedin-ccee8.appspot.com",
  messagingSenderId: "177968065215",
  appId: "1:177968065215:web:feab6e805f3a7cec31740a",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
 
export { db, app, auth, storage };



